<template>
<v-container fluid class="main--text mb-12">
    <faqs/>
</v-container>
    
</template>

<script>

import faqs from '@/components/faqs.vue'
export default {
    name: 'help',
    components: { faqs},
    mounted(){
    scrollTo(0, 0);
  }
}
</script>>
